import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ClientDebtorTopDTO } from '../../minutes/interface/minute-request-kpis.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-minute-top-debtors',
  templateUrl: './minute-top-debtors.component.html',
  styleUrls: ['./minute-top-debtors.component.scss']
})
export class MinuteTopDebtorsComponent implements OnInit, OnChanges{
  @Input() topDebtors: Array<ClientDebtorTopDTO>;
  @ViewChild(MatSort) sort: MatSort;

  public dataSource: MatTableDataSource<ClientDebtorTopDTO>;

  public displayedColumns: string[] = [
    'debtorName',
    'debtorRut',
    'sellInvoiceTotalAmount',
    'numSellInvoices',
    'transferInvoiceTotalAmount',
    'numTransferInvoices',    
  ];

  constructor(){

  }

  ngOnInit(): void {
      this.setDataSource(this.topDebtors);
  }
  ngOnChanges(changes: SimpleChanges): void {    
    this.setDataSource(this.topDebtors);
  }

  private setDataSource(array: Array<ClientDebtorTopDTO>) {
    this.dataSource = new MatTableDataSource<ClientDebtorTopDTO>(array);

    this.dataSource.sort = this.sort;
  }

  public calculateTotalSellInvoices(): number {
    const totalSellInvoices: number = this.topDebtors.reduce((acc, item) =>{
      return acc + item.sellInvoiceTotalAmount
    }, 0)
    return totalSellInvoices;
  }

  public calculateTotalTransferInvoices(): number {
    const totalTransfer: number = this.topDebtors.reduce((acc, item) => {
      return acc + item.transferInvoiceTotalAmount;
    }, 0)
    return totalTransfer;
  }

}
